import { ReactComponent as Phone } from 'Assets/links/black-phone.svg';
import { clearPhoneNumber } from 'Shared/Utils';
import styles from './PhoneLink.module.scss';

type PhoneLinkParams = {
  phoneNumber?: string | null;
  icon?: React.ElementType;
  title?: string;
  customStyles?: string;
};

export const PhoneLink: React.FC<PhoneLinkParams> = ({
  phoneNumber,
  icon,
  title = 'Make a call to the user',
  customStyles = '',
}) => {
  const Icon = icon ? icon : Phone;

  return (
    <a
      className={styles.phoneLink}
      href={`tel:${phoneNumber ? clearPhoneNumber(phoneNumber) : ''}`}
      target="_blank"
      rel="noreferrer"
    >
      <div
        className={`${styles.phoneLink__iconWrapper} ${
          phoneNumber && customStyles
        } ${!phoneNumber && styles.phoneLink__iconWrapper_disabled}`}
      >
        <Icon title={phoneNumber ? title : 'Call unavailable'} />
      </div>
    </a>
  );
};
